/**
 * Dom 커스텀 어트리뷰트
 * @since 0.0.1
 * @author Heungsoo,Ham
 * @enum
 */
export enum DomAttribute {
    /**
     * 이 어트리뷰트를 지닌 DOM 은 폼 빌더의 루트 테그인 Tag.ROOT  만이 지닐 수 있다.
     * 폼이 embed 되어 동작할 때 각 프로젝트는 DomAttribute.APPLICATIONID 로 구분된다.
     * 각 폼은 DomAttribute.FORMID 로 구분된다.
     */
    APPLICATIONID = "bf-application-id",
    FORMID = "bf-form-id",
    PAGEID = "bf-form-id",
    CUSTOMID = "bf-custom-id",
    ENTITYID = "bf-entity-id",
    DESINGMODE = "bf-design-mode",
    PREVIEWMODE = "bf-preview-mode",
    READONLYMODE = "bf-readonly-mode",
    STANDALONEMODE = "bf-standalone-mode",

    /**
     * ACCESSIBILITY
     */
    ACCESSIBILITY = "bf-accessibility",
    ACCESSIBILITYCUSTOM = "bf-custom-accessibility",
    ACCESSIBILITYINVALID = "bf-invalid-accessibility",
    ARIAHIDDEN = "bf-aria-hidden",

    /**
     * 기타
     */
    SELECTED = "bf-selected-component",
    UNDEFINED = "bf-undefined-component",
    MISSING = "bf-missing-component",
    COPYCUT = "bf-copy-cut-component",
    UNDEFINEDDATA = "bf-undefined-data",
    CONFLICTTYPE = "bf-conflict-type",
    EMBEDFORM = "bf-embed-form",
    EMBEDPAGE = "bf-embed-page",
    GLOBALINDEX = "bf-global-index",
    PARENTFORMID = "bf-parent-form-id",
    HIDDEN = "bf-hidden",
    OVERLAY = "bf-overlay",
    REQUIRED = "bf-required",
    PANELINFO = "bf-panel-info",
    PRETABINDEX = "bf-pre-tab-index",
    PREVENTCLICK = "bf-prevent-click",
    PREVENTCONTEXT = "bf-prevent-context",
    HASCLICK = "bf-has-click",
    DISPLAY = "bf-display",

    /**
     * 컴퍼넌트는 라벨, 컴퍼넌트 앨리먼트, 밸리데이션으로 구성된다.
     * <div bf-component-container>
     *     <div bf-label><label for="sample">Sample</label></div>
     *     <div bf-component-clement><input id="sample" type="text"></text></div>
     *     <div bf-validation>this field is required</div>
     * </div>
     * 해당 Dom 의 attribute 를 보고 컴퍼넌트 레이아웃 자동 구성
     */
    COMPONENTCONTAINER = "bf-component-container",
    LABEL = "bf-label",
    COMPONENTELEMENT = "bf-component-element",
    VALIDATION = "bf-validation",
    VALIDATIONERROR = "bf-validation-error",
    VALIDATIONREQUIRED = "bf-validation-required",
    VALIDATIONERRORINDIACTOR = "bf-validation-error-indicator",
    VALIDATIONRESULT = "bf-validation-result",
    VALIDATIONTITLE = "bf-validation-title",
    VALIDATIONACTION = "bf-validation-action",

    /**
     * bf-dock-float: dockTop, dockRight, dockLeft, dockBottom: body를 기준으로 해당 영역의 최끝단에 붙음, 영역 차지
     * bf-dock-float: float: 공중에 떠있는 상태, 영역을 차지하지 않음
     * bf-dock-float: window: window.open 된 상태
     * bf-autofill: bf-dock-float 어트리뷰트를 가진 panel 중 body 에 docking  된 패널의 영역을 제외한 모든 영역을 차지하는 panel
     * <div bf-dock-float="dockTop"></div>: 영역 차지
     * <div bf-dock-float="dockRight"></div>: 영역 차지
     * <div bf-dock-float="dockLeft"></div>:  영역 차지
     * <div bf-dock-float="dockBottom"></div>: 영역 차지
     * <div bf-dock-float="float"></div> : 영역 차지하지 않음
     * <div bf-dock-float="window"></div> : 영역 차지하지 않음
     *
     * <div bf-autofill></div>: 나머지 영역 모두 차지
     *
     * bf-dock-float 이 있고 bf-resize 가 있으면 리사이즈 가능
     * 각각 한 방향으로만 예를 들어 dockTop일 경우 아래로만 리사이징 가능, 리사이징시 다른 관계된 패널 영역 넓이도 자동 조정
     * <div bf-dock-float bf-resize></div>
     */
    AUTOFILL = "bf-autofill",
    DOCKFLOAT = "bf-dock-float",
    RESIZE = "bf-resize",
    PRIORITY = "bf-priority",

    /**
     * 아래 어트리뷰트를 가진 엘리먼트만이 폼 앨리먼트를 드래그 앤드 드롭으로 품을 수 있음
     * 이미 차일드 앨리먼트가 있는 경우 차일드는 하나씩 순차적으로 밀려남
     * <div bf-container>
     */
    CONTAINER = "bf-container",

    /**
     * 드래그 앤 드롭 데이터 읽기 용
     */
    DRAGVALUE = "bf-drag-value",
    DRAGSCHEMA = "bf-drag-schema",

    /**
     * 에디터 등 리사이즈
     */
    RESIZESIZE = "bf-resize-size",
    RESIZEVALUE = "bf-resize-value",

    /**
     * 모달
     * <div bf-modal-content>
     *     <div bf-modal-header>모달 타이틀 / 기본 버튼</div>
     *     <div bf-modal-body>모달 컨텐츠</div>
     *     <div bf-modal-footer>모달 푸터</div>
     * </div>
     */
    MODALCONTENT = "bf-modal-content",
    MODALHEADER = "bf-modal-header",
    MODALBODY = "bf-modal-body",
    MODALFOOTER = "bf-modal-footer",
    MODALLINKID = "bf-modal-link-id",
    MODALRESIZE = "bf-modal-resize",
    MODALOVERFLOW = "bf-modal-overflow",

    MODALCLOSE = "bf-modal-close",
    MODALBUTTONCLOSE = "bf-modal-button-close",
    MODALBUTTONAPPLY = "bf-modal-button-apply",
    MODALTABIGNORE = "bf-modal-tab-ignore",

    MODALACTIVITY = "bf-modal-activity",

    /**
     * 그리드
     */
    GRIDID = "bf-grid-id",
    GRIDLINKID = "bf-grid-link-id",
    GRIDPK = "bf-grid-pk",
    GRIDSEARCHCONTAINER = "bf-grid-search-container",
    GRIDACTIONCONTAINER = "bf-grid-action-container",
    GRIDBODYCONTAINER = "bf-grid-body-container",
    GRIDDIRECTCONTAINER = "bf-grid-direct-container",
    GRIDDIRECTPARENT = "bf-grid-direct-parent",
    GRIDCHECKBOX = "bf-grid-checkbox",
    GRIDCOMPONENT = "bf-grid-component",
    GRIDROOT = "bf-grid-root",
    GRIDFROM = "bf-grid-from",
    GRIDBUTTON = "bf-grid-button",
    GRIDEDITID = "bf-grid-edit-id",
    GRIDCONTEXTID = "bf-grid-context-id",
    GRIDIN = "bf-grid-in",

    /**
     * 페이지 블럭
     * <div bf-block></div>
     */
    BLOCK = "bf-block",

    /**
     * 드래그 앤드 드롭
     * <div bf-draggable></div>
     * 디자인 타임에서 bf-container 에 위치할 수 있다
     */
    DRAGGABLE = "bf-draggable",

    /**
     * Data modeler
     */
    DATAMODELER = "bf-data-modeler",

    /**
     * I18N
     */
    I18N = "bf-i18n",
    I18NFOCUS = "bf-i18n-focus"
}
